import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=a760b882&lang=pug&"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTypeSelect.vue?vue&type=style&index=0&id=a760b882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports